<div class="callback-shell">
  <section class="callback-card glass-panel">
    <p class="eyebrow">Facebook Signup</p>
    <h1 class="section-title">Returning to PingoraX</h1>
    <p class="subtle-copy">{{ message }}</p>
  </section>
</div>
